import React, { useState, useEffect } from "react";
import "react-dropdown/style.css";
import LayoutV2 from "containers/LayoutV2";
import TrichLapApi from "service/thuChiTrichLapApi";
import UserApi from "service/userApi";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { TableDanhSachTrichLap } from "./TableDanhSachTrichLap";
export const DanhSachTrichLapDuPhong = () => {
  const [quyenDanhSach, setQuyenDanhSach] = useState(null);
  const [dataDanhSach, setDataDanhSach] = useState([]);

  const initSearch = {
    search: "",
    pageIndex: 1,
    pageSize: 20,
  };

  const [dataSearch, setDataSearch] = useState(initSearch);

  const getQuyen = () => {
    UserApi.getAllQuyen()
      .then((response) => {
        setQuyenDanhSach(
          response.status === 200 &&
            Array.isArray(response.data) &&
            response.data.some(
              (e) => (e.ModuleCode || "").toLowerCase() === "trichlapduphong",
            ),
        );
      })
      .catch(() => setQuyenDanhSach(false));
  };

  const onSearch = () => {
    TrichLapApi.DanhSach(
      dataSearch.search,
      dataSearch.pageIndex,
      dataSearch.pageSize
    ).then((response) => {
      console.log("responseresponseresponse", response);
      setDataDanhSach(response.data);
    });
  };

  const handlePageChange = (pageNumber) => {
    console.log("pageNumber", pageNumber);
    dataSearch.pageIndex = pageNumber;
    setDataSearch(dataSearch);
    onSearch(dataSearch);
  };

  useEffect(() => {
    getQuyen();
  }, []);

  useEffect(() => {
    if (quyenDanhSach) onSearch();
  }, [dataSearch, quyenDanhSach]);

  return (
    <LayoutV2>
      {quyenDanhSach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Trích lập dự phòng</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop
                      onSearch={onSearch}
                      setDataSearch={setDataSearch}
                      dataSearch={dataSearch}
                    />
                    {/* <SearchBarMobile /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSachTrichLap
            dataDanhSach={dataDanhSach}
            onSearch={onSearch}
            setDataSearch={setDataSearch}
            dataSearch={dataSearch}
            handlePageChange={handlePageChange}
          />
        </div>
      )}
      {quyenDanhSach === false && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Trích lập dự phòng</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
